function redirectRealEstate(str){
  window.location = 'home-price-trends/' + str;
}

$("img").unveil();

function buttonUp(){
  var inputVal = $('.searchbox-input').val();
  inputVal = $.trim(inputVal).length;
  if( inputVal !== 0){
    // $('.searchbox-icon').css('display','none');
  } else {
    $('.searchbox-input').val('');
    // $('.searchbox-icon').css('display','block');
  }
}

function setStickyHeaders(mobileOffset) {
    var width = $(window).width();

    if (width<=768) {
      $('#simpletable').stickyTableHeaders({fixedOffset: mobileOffset});
    } else {
      $('#simpletable').stickyTableHeaders({fixedOffset: $('#page-navigation')});
    }

    $(window).resize(function() {
      var width = $(window).width();

      if (width<=768) {
        $('#simpletable').stickyTableHeaders({fixedOffset: mobileOffset});
      } else {
        $('#simpletable').stickyTableHeaders({fixedOffset: $('#page-navigation')});
      }
    });
}
